<template>
  <div
    @click="onClickMask"
    class="mask"
    :style="customStyle"
    @touchmove.prevent
    v-if="visiable"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BaseModal',
  props: ['visiable', 'customStyle', 'onHide'],
  methods: {
    onClickMask() {
      if (this.onHide) {
        this.onHide();
      }
      this.$emit('on-hide');
    },
  },
};
</script>

<style scoped>
  .mask {
    align-items: center;
    background: rgba(0, 0, 0, 0.50);
    display: flex;
    justify-content: center;
    left: 0;
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100vw;
    z-index: 999;
  }
</style>
